import { defineComponent as _defineComponent } from 'vue';
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreatorHelpHeader',
    setup(__props) {
        const isExpanded = ref(false);
        function clickForHelp() {
            isExpanded.value = !isExpanded.value;
            return isExpanded.value;
        }
        return { __sfc: true, isExpanded, clickForHelp, faChevronDown, faChevronUp, FontAwesomeIcon, localize };
    }
});
